import React from "react";
import {
  FormControl,
  FormLabel,
  FormHelperText,
  Rating as MuiRating,
} from "@mui/material";
import PropTypes from "prop-types";

Rating.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function Rating(props) {
  const {
    item,
    value = false,
    error = null,
    onChange,
    showErrorText = false,
    disabled = false,
  } = props;

  let inputValue = Number(value);

  if (!value) inputValue = null;
  let helperText = "";
  if (showErrorText) helperText = error;
  return (
    <FormControl {...(error && { error: true })}>
      <FormLabel>{item.label}</FormLabel>
      <MuiRating
        label={item.label}
        name={item.name}
        value={inputValue}
        onChange={onChange}
        disabled={disabled}
        precision={item.precision || 1}
      />{" "}
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
